export const getArgs = (input: any[]): { args: any[]; rest: any[] } => {
  const [first, ...rest] = input

  return Array.isArray(first)
    ? { args: first, rest }
    : { args: [], rest: input }
}
